import { Component, Input, OnInit } from '@angular/core';
import { AuthStoreService, ContentStoreService, NavMenu } from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { User } from 'src/app/core/model/user';

@UntilDestroy()
@Component({
  selector: 'app-footer-top-nav',
  templateUrl: './footer-top-nav.component.html',
  styleUrls: ['./footer-top-nav.component.scss'],
})
export class FooterTopNavComponent implements OnInit {
  @Input() loggedIn = false;
  openLinksInNewPage = false;
  acceptedTermsConditions: boolean | null = null;
  isDistributor = false;

  year: string;

  footerMenuHelp: NavMenu;
  footerMenuAbout: NavMenu;
  footerMenuPartners: NavMenu;

  constructor(private contentStore: ContentStoreService, private authStore: AuthStoreService) {}

  ngOnInit(): void {
    this.contentStore.footerMenus$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((footerMenus) => {
      this.footerMenuHelp = footerMenus[0];
      this.footerMenuAbout = footerMenus[1];
      const menuPartnersSections = footerMenus.filter(
        (f: any) => (f.name as string).toLocaleLowerCase() === 'our partners'
      );
      if (menuPartnersSections.length > 0) {
        this.footerMenuPartners = menuPartnersSections[0];
      }

      this.updateTopFooter();
    });

    this.authStore.userSettings$.pipe(untilDestroyed(this), filter(Boolean)).subscribe((userSettings: any) => {
      this.acceptedTermsConditions = (userSettings?.user as User)?.acceptedTermsConditions === true;
      const userRole = (userSettings?.user as User)?.userRole?.name ?? '';
      this.isDistributor = userRole === 'lenovo.elevate.disti.access';

      this.updateTopFooter();
    });
  }

  private updateTopFooter() {
    if (
      this.acceptedTermsConditions !== null &&
      this.acceptedTermsConditions === false &&
      this.footerMenuHelp &&
      !this.isDistributor
    ) {
      this.openLinksInNewPage = true;
      this.footerMenuHelp.items = this.footerMenuHelp.items.filter((item) => !item.url.includes('give-feedback'));
    }
  }
}
